import { render, staticRenderFns } from "./AnamnesiListPage.vue?vue&type=template&id=1e7d5954"
import script from "./AnamnesiListPage.vue?vue&type=script&lang=js"
export * from "./AnamnesiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports